export default function () {
    return {
        list: [],
        fullTable: [],
        grandTotalsRow: {},
        lastFetchParams: null,
        localFilterModel: {},
        localSortingModel: [],
        current: undefined,
        currentRecord: null,
        rowBeingDragged: null,
        currentRecordLastFetchedRemoteState: null,
        pagination: {},
        selectedIds: [],
        distinctValuesOfFieldsOnRemote: {}
    };
}
